const INITIAL_STATE = {
    selectedCountry: '',
}


const settingsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "setSelectedCountry" : return {...state, selectedCountry: action.payload};
        default : return state;
    }
}


export default settingsReducer;